/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface EntityRef {
  id: string;
  label: string;
  avatar_url?: string | null;
}
